export default __webpack_public_path__ + "static/media/down_arrow.2e3594fe.svg";